import request from "@/plugins/axios.js";

const getJobProgress = data => {
  return request({
    url: "/Qzjd/queryQzjd",
    method: "post",
    data
  });
};
/* 查看报道通知 */
const getReportInfomation = data => {
  return request({
    url: "/Qzjd/queryBdtz",
    method: "post",
    data
  });
};
/* 查看笔试通知 */
const getWrittenMsg = data => {
  return request({
    url: "/Qzjd/queryBstz",
    method: "post",
    data
  });
};
/* 查看面试通知 */
const getInterviewMsg = data => {
  return request({
    url: "/Qzjd/queryMstz",
    method: "post",
    data
  });
};
/* 确认参加笔试 */
const confirmWritten = data => {
  return request({
    url: "/Qzjd/doQrcjbs",
    method: "post",
    data
  });
};
/* 确认参加面试 */
const confirmInterview = data => {
  return request({
    url: "/Qzjd/doQrcjms",
    method: "post",
    data
  });
};
export default {
  getJobProgress,
  getWrittenMsg,
  getInterviewMsg,
  confirmWritten,
  confirmInterview,
  getReportInfomation
};
